module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P2r4Ky/tc-custom/9781681883175.jpg?1699740978776",
      "alt": "This image is the cover for the book Ultimate Bushcraft Survival Manual, Outdoor Life"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ultimate Bushcraft Survival Manual, Outdoor Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The ultimate guide to living in the wild from finding shelter and food to knowing the many uses for antlers, mud, animal fat and more.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Imagine being dropped in the woods with little more than a knife, your wits, and the shirt on your back. You’d need more than luck to survive. You’d need the knowledge and skills covered in "), _c('i', [_vm._v("Ultimate Bushcraft Survival Manual")]), _vm._v("."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this book, survival expert Tim MacWelch examines how primitive cultures around the world and throughout history have made their own shelter, weapons, tools, and more. He also shares clever, MacGuyver-style ideas for repurposing anything you might find in your pockets or pack. Whether your goal is to test yourself against nature, be prepared for any catastrophe, or learn more about traditional survival techniques, this is the book for you.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim MacWelch, The Editors of Outdoor Life\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weldonowen\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0